import React, {useState, useEffect} from 'react';
import * as StyledComponents from '../StyledComponents';
import get from 'lodash/get';
import { useUnifyAdminStore } from '../AdminStore';

interface IAdminDataSideSheet {
  children: React.ReactNode;
  isCollapse: boolean;
  sidesheetName?: string;
}

export const OutageAdminDataSideSheet = ({
  children,
  isCollapse,
  sidesheetName=''
}: IAdminDataSideSheet): JSX.Element => {

  const sideSheetData = useUnifyAdminStore(
    (state) => state.productOutageSideSheetData
  );

  const showFileData = get(sideSheetData, 'showFileData', '');

  const [showBulkUploadData, setShowBulkUploadData] = useState(get(sideSheetData, 'showFileData', ''));

  useEffect(()=>{
    setShowBulkUploadData(showFileData);
  },[showFileData]);

  return (
    <StyledComponents.StyledSideSheetContainer
      data-testid="side-sheet"
      width={showBulkUploadData === true && sidesheetName === 'Outage' ? '850px': '21.8vw'}
      isCollapsed={isCollapse}
    >
      {children}
    </StyledComponents.StyledSideSheetContainer>
  );
};
